var Marionette = require('marionette'),
    SearchPillsCollectionView = require('./searchPills/searchPillCollectionView'),
    NewSearchFormView = require('../../searchView/view');


module.exports = Marionette.LayoutView.extend({

    template: require('./template.hbs'),

    initialize: function( options ) {

        this.channel = options.channel;

        this.listenTo( this.channel, 'findAndRedact:updateSearchPills', this._showPillCollectionView );

    },

    regions: {
        searchPillsRegion:  '#fr-results-search-collection'
    },

    serializeData: function() {

        var state = this.channel.request('state'),
            numberOfSearches = state.getNumberOfSearches();

        return {
            numberOfSearches: numberOfSearches
        };

    },

    ui: {
        addSearchBtn:   '#fr-search-results-add-search',
        clearBtn:       '#fr-search-results-clear'
    },

    events: {
        'click @ui.addSearchBtn':   'addNewSearchButtonClick',
        'click @ui.clearBtn':       'clearButtonClick'
    },


    onBeforeShow: function() {

       this._showPillCollectionView();

    },

    _showPillCollectionView: function() {

        this.searchPillsRegion.show( new SearchPillsCollectionView({
            channel: this.channel,
            collection: this.channel.request('state').get('searches') // maybe have a different collection ....  new Backbone.Collection( // .getSearchModels() -- need to show those that returned none
        }));

    },


    addNewSearchButtonClick: function() {

        this.channel.trigger( 'findAndRedact:showAddSearchModal' );

    },

    clearButtonClick: function() {

        this.channel.trigger('findAndRedact:clearSearch');
    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/findAndRedact/layout/resultsView/searchesView/view.js
 ** module id = 638
 ** module chunks = 0
 **/